import { FC } from "react";
import { Stack, styled, Typography } from "@mui/material";
import { IconReplay, IconZoomIn, IconZoomOut } from "@/assets/icons";
import { IconBox } from "@/components/elements/IconBox";
import { black, background } from "@/theme/colors";
import { MAX_SCALE, MIN_SCALE } from "@/features/talent/components/talent-scan-image/zoom-pan-geometry";

type TZoomControlsProps = {
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  className?: string;
};

export const ZoomControls: FC<TZoomControlsProps> = ({ scale, onZoomIn, onZoomOut, onReset, className }) => {
  return (
    <ControlsContainer className={className}>
      <ZoomButton onClick={onZoomOut} disabled={scale <= MIN_SCALE} title="縮小">
        <IconZoomOut fontSize={16} color={scale <= MIN_SCALE ? black[90] : black[60]} />
      </ZoomButton>
      <ZoomButton onClick={onZoomIn} disabled={scale >= MAX_SCALE} title="拡大">
        <IconZoomIn fontSize={16} color={scale >= MAX_SCALE ? black[90] : black[60]} />
      </ZoomButton>
      <ZoomButton onClick={onReset} title="表示リセット">
        <IconReplay fontSize={16} color={black[60]} />
      </ZoomButton>
      <ZoomPercentage variant="cap12">{Math.round(scale * 100)}%</ZoomPercentage>
    </ControlsContainer>
  );
};

const ControlsContainer = styled(Stack)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px 12px;
  background-color: ${background.white};
  border-top: 1px solid ${black[95]};
  height: 44px;
  flex-shrink: 0;
`;

const ZoomButton = styled(IconBox)`
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background-color: ${black[95]};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const ZoomPercentage = styled(Typography)`
  min-width: 40px;
  text-align: right;
  color: ${black[70]};
`;
